// GENERATED FILE — DO NOT EDIT BY HAND.
//
// Regenerate with, from the nouns_flutter_demo repo root:
//   dart run tool/gen_opcodes_ts.dart
//
// Source of truth: lib/features/utils/op_codes.dart
// Mirrored in:     game-server-go/features/matches/runtime/op_codes.go (Go, `iota + 1`)
//
// opCode integers are a WIRE CONTRACT (CLAUDE.md §5). Adding
// one means editing the Dart file, the Go file, and
// regenerating this one, all in the same change. Never
// renumber or reuse a value.

export const OpCode = {
  newUserJoined: 1,
  joinedMatch: 2,
  selectAlphabetRequest: 3,
  alphabetSelected: 4,
  newRoundBegin: 5,
  submitAnswers: 6,
  roundResults: 7,
  startGame: 8,
  stop: 9,
  matchEnd: 10,
  acknowledgeResults: 11,
  allowGameStart: 12,
  acknowledgeJoin: 13,
  hostQuit: 14,
  playerDisconnected: 15,
  quitRequest: 16,
  skipResults: 17,
  userToSelectNextAlphabet: 18,
  matchFull: 19,
  kickedOutTimedOut: 20,
  updateHost: 21,
  playerReconnected: 22,
  acknowledgeAnswersReceived: 23,
  classroomsCreated: 24,
  classroomsExpired: 25,
  systemSelectAlphabet: 26,
  nextRoundDeadlineUpdate: 27,
} as const;

export type OpCodeName = keyof typeof OpCode;
export type OpCodeValue = (typeof OpCode)[OpCodeName];

/// Reverse lookup, for logs and dev tooling only — never for
/// dispatch. Dispatch switches on the numeric value.
export const OP_CODE_NAMES: Readonly<Record<number, string>> = {
  1: 'newUserJoined',
  2: 'joinedMatch',
  3: 'selectAlphabetRequest',
  4: 'alphabetSelected',
  5: 'newRoundBegin',
  6: 'submitAnswers',
  7: 'roundResults',
  8: 'startGame',
  9: 'stop',
  10: 'matchEnd',
  11: 'acknowledgeResults',
  12: 'allowGameStart',
  13: 'acknowledgeJoin',
  14: 'hostQuit',
  15: 'playerDisconnected',
  16: 'quitRequest',
  17: 'skipResults',
  18: 'userToSelectNextAlphabet',
  19: 'matchFull',
  20: 'kickedOutTimedOut',
  21: 'updateHost',
  22: 'playerReconnected',
  23: 'acknowledgeAnswersReceived',
  24: 'classroomsCreated',
  25: 'classroomsExpired',
  26: 'systemSelectAlphabet',
  27: 'nextRoundDeadlineUpdate',
};
